import React from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner } from '@paypalcorp/pp-react';
import { CaptionText } from './CaptionText';

import './LoadingScreen.less';

export const LoadingScreen = ({ loadingText }) => (
    <div className="LoadingScreen">
        <div className="spinner_container">
            <LoadingSpinner className="loadSpinner" screenReaderText="loading" size="xl" />
            <CaptionText className="loadingCaptionText" text={loadingText} />
        </div>
    </div>
);

LoadingScreen.propTypes = {
    loadingText: PropTypes.string.isRequired
};